export const requestIdleCallback = window.requestIdleCallback || function (callback) {
  const start = Date.now();
  return setTimeout(() => {
    callback({
      didTimeout: false,
      timeRemaining: () => {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
};
export const cancelIdleCallback = window.cancelIdleCallback || function (handle) {
  clearTimeout(handle);
};